<template lang='pug'>
EventToProp(
  v-slot='{ timestamp, updateTimestamp: reload }'
)
  div(
    :key='timestamp'
  )
    slot(
      :reload='reload'
    )
</template>

<script>
import EventToProp from './EventToProp.vue';

export default
{
  components:
  {
    EventToProp
  }
};
</script>